import React from 'react';
import './PersonalLoanPrequalOffer.scss';
import { Button } from 'components/form/Button/Button';
import 'partial/OfferDetails/components/OfferReviewView/OfferReviewView.scss';
import { LoanTermsSection } from '../StandardPersonalLoanOffer/index';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import PlBadgeTags from '../fragments/PlBadgeTags/PlBadgeTags';
import { Image } from 'components/Image/Image';
import { useConfig } from 'hook/config.hook';
import { Link } from 'components/navigation/Link/Link';

function ButtonSection({ clickApplyHandler, offerMetadata }) {
  const { config } = useConfig();
  return (
    <div className="buttonSection margB40 m-margB16">
      <div className="buttonContainer">
        <Button
          mrphType="primary"
          onClick={clickApplyHandler}
          className="format100 border-rad100px"
        >
          <FlexContainer className="justify-center align-items-center">
            <Image imgClass={'standardLockIcon'} />
            Apply for Offer
          </FlexContainer>
        </Button>
      </div>
      <div className="fclear pad4" />
      <div
        className="text-center productDetailLabel caption"
        data-testid="ccDetailsLinkLabel"
      >
        on {offerMetadata.name}'s {config?.secureWebsiteDisclaimer}
      </div>
    </div>
  );
}

function TopSection({
  offerMetadata,
  prequal,
  clickPrequalHandler,
  clickDetailsHandler,
  clickApplyHandler,
  seenPixel,
  offerImageLinkUrlProxy,
}) {
  return (
    <div className="cardSection margB16">
      <PlBadgeTags offerMetadata={offerMetadata} datatestid={'plbadges'} />
      <div className="FlexContainer justify-between mFlex-column">
        <div className="cardCol FlexContainer flex-column t-Width100">
          {seenPixel}
          <div className="margB8">
            <img
              alt={`${offerMetadata?.name} offer`}
              onClick={clickDetailsHandler}
              src={offerImageLinkUrlProxy}
              className="productImage"
              data-testid="creditCardImage"
            />
          </div>
        </div>
        <div className="cardButtonCol mobileHide">
          <ButtonSection
            clickApplyHandler={clickApplyHandler}
            clickPrequalHandler={clickPrequalHandler}
            offerMetadata={offerMetadata}
            prequal={prequal}
          />
        </div>
      </div>
    </div>
  );
}

function LoanTermsAndApplySection({
  offerMetadata,
  clickDetailsHandler,
  clickApplyHandler,
  clickPrequalHandler,
  prequal,
}) {
  const {
    apr,
    termMonths,
    displayTerm,
    loanAmount,
    monthlyPayment,
    poweredBy,
  } = offerMetadata;

  return (
    <div className="loanTermsSection">
      <LoanTermsSection
        apr={apr}
        termMonths={termMonths}
        displayTerm={displayTerm}
        loanAmount={loanAmount}
        monthlyPayment={monthlyPayment}
        totalCost={offerMetadata.totalCost}
        totalCostDisplay={offerMetadata.totalCostDisplay}
      />
      <FlexContainer className="desktopHide">
        <ButtonSection
          clickApplyHandler={clickApplyHandler}
          clickPrequalHandler={clickPrequalHandler}
          offerMetadata={offerMetadata}
          prequal={prequal}
        />
      </FlexContainer>
      <div className="caption mtext-center bold m-margB8" color="fontBlue100">
        <Link
          className="personalLoansDetailsLink"
          href={offerMetadata.tcUrl}
          onClickCallback={clickDetailsHandler}
          data-testid="plDetailsLink"
          ariaLabel="Details and rate disclosure"
          tabIndex="0"
          role="button"
        >
          Details and rate disclosure
        </Link>
        <div className="mobileHide">
          {poweredBy && (
            <span className="fright fontGray300 notBold m-block">
              {poweredBy}
            </span>
          )}
        </div>
      </div>
      <div className="desktopHide">
        {poweredBy && (
          <span className="fright fontGray300 notBold m-block m-text-12 m-margT24">
            {poweredBy}
          </span>
        )}
      </div>
    </div>
  );
}

export function PersonalLoanPrequalOffer(props) {
  const { config } = props;
  return (
    <>
      <div className={`plPrequalOffer margB16`}>
        <div className="FlexContainer flex-column pad24 t-fPad16">
          <div className="FlexContainer flex-column">
            <TopSection {...props} />
            <LoanTermsAndApplySection {...props} />
          </div>
        </div>
      </div>
    </>
  );
}
